"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Color = require("color");
exports.kColors = {
    brand1: Color.rgb(255, 51, 51),
    brand2: Color.rgb(33, 32, 60),
    brand3: Color.rgb(118, 112, 138),
    brand4: Color.rgb(50, 186, 88),
    bg1: Color.rgb(18, 18, 33),
    bg2: Color.rgb(247, 247, 247),
    grey1: Color.rgb(153, 153, 153),
    grey2: Color.rgb(194, 194, 194),
    grey3: Color.rgb(229, 229, 229),
    grey4: Color.rgb(245, 245, 245),
    white: Color.rgb(255, 255, 255),
    textlight: Color.rgb(255, 255, 255),
    textdark: Color.rgb(0, 0, 0),
    success: Color.rgb(76, 157, 55),
    warning: Color.rgb(253, 142, 60),
    error: Color.rgb(194, 40, 60),
};
// NOTE: needs to be kept in sync with the type definitions
// the type definition will ensure no additional keys slip in, but it will
// not ensure the list is an exhaustive representation of all defined
// color types
exports.getColorKeys = function () {
    return [
        'brand1',
        'brand2',
        'brand3',
        'brand4',
        'bg1',
        'bg2',
        'grey1',
        'grey2',
        'grey3',
        'grey4',
        'white',
        'textlight',
        'textdark',
        'success',
        'warning',
        'error',
    ];
};
exports.getColor = function (color) { return exports.kColors[color]; };
exports.getHex = function (color) { return exports.getColor(color).hex(); };
// basically a list of colors for avatars, because well the "clever" ways
// to create this list on the fly are all computationally expensive, see:,
// https://stackoverflow.com/questions/309149/generate-distinctly-different-rgb-colors-in-graphs
//
// The list below was taken from the "729 entries" list and then eyeballed down
// to the best 50 (IMO)
exports.kAvatarColors = [
    '#FB5514',
    '#00587F',
    '#0BC582',
    '#F98500',
    '#B7D802',
    '#58018B',
    '#B70639',
    '#D19012',
    '#796EE6',
    '#FDEC87',
    '#5D9608',
    '#372A55',
    '#248AD0',
    '#D7C70B',
    '#932C70',
    '#D4C67A',
    '#168E5C',
    '#16C0D0',
    '#8C41BB',
    '#94C661',
    '#F8907D',
    '#576094',
    '#8489AE',
    '#860E04',
    '#FBC206',
    '#A1A711',
    '#C660FB',
    '#9F98F8',
    '#1167D9',
    '#5E7A6A',
    '#76E0C1',
    '#65407D',
    '#72A46E',
    '#FEB8C8',
    '#B95C69',
    '#C4C8FA',
    '#DE98FD',
    '#719FFA',
    '#0D841A',
    '#9DB3B7',
    '#B14F8F',
    '#D26A5B',
    '#6B5F61',
    '#9B72C2',
    '#923A52',
    '#5140A7',
    '#BC14FD',
    '#C6A62F',
    '#5E7C99',
    '#693955',
    '#6C6E82',
    '#D0AFB3',
    '#493B36',
    '#AC93CE',
    '#C4BA9C',
    '#09C4B8',
    '#69A5B8',
    '#374869',
    '#C04841',
    '#C36333',
    '#700366',
    '#8A7A93',
    '#B503A2',
    '#D17190',
    '#A0F086',
    '#7B41FC',
    '#0EA64F',
    '#017499',
    '#08A882',
    '#7300CD',
    '#A9B074',
    '#4E6301',
    '#AB7E41',
    '#547FF4',
    '#134DAC',
    '#056164',
    '#C264BA',
    '#277442',
    '#1BDE4A',
    '#826958',
    '#BAFCE8',
    '#7D8475',
    '#8CCF95',
    '#726638',
    '#FEA8EB',
    '#EAFEF0',
    '#6B9279',
    '#C2FE4B',
    '#304041',
    '#1EA6A7',
    '#054B17',
    '#F4C673',
    '#9DBAA8',
    '#775551',
    '#565BCC',
    '#80D7D2',
    '#7AD607',
    '#696F54',
    '#87089A',
    '#242235',
    '#7DB00D',
    '#BFC7D6',
    '#D5A97E',
    '#433F31',
    '#FDB2AB',
    '#D586C9',
    '#7A5FB1',
    '#32544A',
    '#EFE3AF',
    '#859D96',
    '#2B8570',
    '#8B282D',
    '#E16A07',
    '#4B0125',
    '#021083',
    '#C78571',
    '#7FB9BC',
    '#FC7F4B',
    '#8D4A92',
    '#6B3119',
];
exports.getNextAvatarColor = function (used) {
    // normalize the used colors to hex format (we don't want to assume that everyone is going to play nice)
    var usedAsHex = used.map(function (color) { return Color(color).hex(); });
    return exports.kAvatarColors.find(function (hex) { return usedAsHex.indexOf(hex) < 0; }) || '#000';
};
